import React from 'react';
import { Hero } from '../components/home/Hero';
import { Problem } from '../components/home/Problem';
import { OriginSystem } from '../components/home/OriginSystem';
import { Pricing } from '../components/home/Pricing';
import { DemoSection } from '../components/home/DemoSection';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  return <div className="w-full" data-id="element-332" data-mp="2x7iuf3g0b6mv">
      <Hero data-id="element-333" data-mp="1ziqu7m9zzul7" />
      <Problem data-id="element-334" data-mp="1ziz6pd27kxvv" />
      <OriginSystem data-id="element-335" data-mp="1zjie3zu8g3vn" />
      <Pricing data-id="element-336" data-mp="1zk1zxrn07cey" />
      <DemoSection data-id="element-337" data-mp="24h0rq3j7379z" />
      <FinalCTA data-id="element-338" data-mp="24gilqf6qdeov" />
    </div>;
}